/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "climate-wind-a7fd496d--sprite",
  "use": "climate-wind-a7fd496d--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"climate-wind-a7fd496d--sprite\"><g transform=\"translate(-1449 -462)\"><g transform=\"translate(1449 462)\" fill=\"#fff\" stroke=\"#e5ebf6\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g><g transform=\"translate(-1585 -462)\"><rect width=\"36\" height=\"36\" transform=\"translate(1585 462)\" fill=\"none\" /><g transform=\"translate(1588 467)\"><g transform=\"translate(0)\"><g transform=\"translate(2.006)\"><path d=\"M22.138,8.155A6.084,6.084,0,0,1,28.389,2.2c3.313.122,5,1.4,5.75,3.648a6.371,6.371,0,0,1-1,6.2c-1.375,1.581-5.188,2.128-7.125,2.128H5.7\" transform=\"translate(-5.7 -2.194)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /><path d=\"M9.7,29.2H28.365s3.582-.243,4.9,2.371a5.214,5.214,0,0,1-.817,5.9,5.594,5.594,0,0,1-5.782.79c-1.068-.426-3.519-1.763-3.017-4.5\" transform=\"translate(-7.268 -12.098)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /></g><g transform=\"translate(0 1.024)\"><path d=\"M2.4,10.639c1.459,0,7.478.122,10.7-.122s4.5-3.891,2.128-5.836a3.017,3.017,0,0,0-4.985,1.581\" transform=\"translate(-2.4 -3.878)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /></g></g></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
